<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-04-28 11:12:38
 * @LastEditTime: 2026-06-22 13:54:20
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 超图算
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\supplyManagement\controlSet\components\processDiffer.vue
-->
<template>
  <el-dialog
    :visible.sync="superGraphDig"
    width="1100px"
    :close-on-click-modal="false"
    @open="openSupplySet"
    @close="closeDig" 
  >
    <span slot="title" class="dialog-title">超图算流程控制</span>
    <div class="tabtop" style="width: 380px">
      <div
        v-for="(item, index) in dataTypeList"
        :key="index"
        @click="choose(item.status)"
      >
        <div :class="dataType == item.status ? 'active' : 'text'">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div v-if="dataType == 1" class="super-graph-content">
      <div>
        <el-row class="title" style="margin-bottom: 20px;">
          <el-col :span="24">
            <span>单计划超图算管控：超过图算后，未确认项目不能新增新计划</span>
          </el-col>
        </el-row>
        
        <el-row v-for="(item, index) in paramDataList" :key="index" class="text" style="margin-top: 15px">
          <el-col :span="6">
            <span>强度等级 </span>
            <el-select 
              v-model="item.strengthGradeArr" 
              multiple 
              placeholder="请选择" 
              style="width: 180px; margin-left: 10px;"
            >
              <el-option 
                v-for="g in strengthGradeList" 
                :key="g.id" 
                :label="g.name" 
                :value="g.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5" style="text-align: right; padding-right: 10px;">
            <span>生产量超图算量比例 ≥</span>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model.number="item.rate"
              type="number"
              placeholder=""
              style="width: 100%"
            >
            </el-input>
          </el-col>
          <el-col :span="6" style="padding-left: 10px;">
            <span>%，（票面量-余料-富余量）/图算量</span>
          </el-col>
          <el-col :span="4">
            <el-button  size="small" class="bottom_all" @click="addRow">添加</el-button>
            <el-button  v-if="index > 0"  size="small" class="bottom_two" @click="delRow(index)">删除</el-button>
          </el-col>
        </el-row>

        <el-row class="text" style="margin-top: 25px; padding-top: 15px; border-top: 1px dashed #ebeef5;">
          <el-col :span="6"></el-col>
          <el-col :span="5" style="text-align: right; padding-right: 10px;">
            <span>超时缓冲时间</span>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model.number="globalConfirmDays"
              type="number"
              placeholder=""
              style="width: 100%"
            >
            </el-input>
          </el-col>
          <el-col :span="10" style="padding-left: 10px;">
            <span>天后，限制计划</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDig()">关 闭</el-button>
      <el-button class="bottom_all" @click="saveSupplySet">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  querySupplyControlParam,
  updateSupplyControlParam,
} from "@/api/internetSales/supplyManagement.js";
import { getLists } from "@/api/smart/schedul/c.js";

export default {
  props: {
    superGraphDig: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataType: 1,
      strengthGradeList: [], // 强度等级下拉列表
      globalConfirmDays: "", // 全局超时缓冲时间
      // 动态行数据列表（正常显示的数据）
      paramDataList: [
        {
          id: "",
          strengthGradeArr: ["其他"], 
          rate: "", 
        }
      ],
      // 收集被删除的已有数据（带有id的数据，用于保存时传 status: 0）
      deletedList: [],
      dataTypeList: [
        {
          value: "常规管控策略",
          status: 1,
        },
        {
          value: "非常规管控策略",
          status: 0,
        },
      ],
    };
  },
  created() {
    this.getDictData();
  },
  methods: {
    // 获取强度等级字典
    getDictData() {
      getLists().then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            if (item && item.typeName == "强度等级") {
              this.strengthGradeList = item.list || [];
            }
          });
          
          // 手动在下拉选项中追加“其他”
          const hasOther = this.strengthGradeList.some(g => g.id === "其他" || g.name === "其他");
          if (!hasOther) {
            this.strengthGradeList.push({ id: "其他", name: "其他" });
          }
        }
      });
    },
    // 添加行
    addRow() {
      this.paramDataList.push({
        id: "",
        strengthGradeArr: ["其他"],
        rate: "",
      });
    },
    // 删除行
    delRow(index) {
      const rowData = this.paramDataList[index];
      // 如果这条数据已经有 id（表示是后端返回的已有数据），把它放到待删除列表里
      if (rowData.id) {
        this.deletedList.push(rowData);
      }
      // 从页面显示的列表中移除
      this.paramDataList.splice(index, 1);
    },
    closeDig() {
      this.$emit("closeDig");
    },
    // 保存设置
    saveSupplySet() {
      let formattedActiveData = this.paramDataList.map(item => {
        let strengthJsonArray = item.strengthGradeArr.map(selectedId => {
          let found = this.strengthGradeList.find(g => g.id === selectedId);
          return {
            id: found ? found.name : selectedId, 
            name: found ? found.name : selectedId
          };
        });

        return {
          id: item.id || "",
          strengthGrade: JSON.stringify(strengthJsonArray),
          rate: item.rate,
          confirmDays: this.globalConfirmDays,
          status: 1 // 正常数据传 1
        };
      });

      // 处理被删除的历史数据 (status: 0)
      let formattedDeletedData = this.deletedList.map(item => {
        let strengthJsonArray = item.strengthGradeArr.map(selectedId => {
          let found = this.strengthGradeList.find(g => g.id === selectedId);
          return {
            id: found ? found.name : selectedId, 
            name: found ? found.name : selectedId
          };
        });
        return {
          id: item.id,
          strengthGrade: JSON.stringify(strengthJsonArray),
          rate: item.rate,
          confirmDays: this.globalConfirmDays,
          status: 0 // 被删除数据传 0
        };
      });

      // 将正常数据和要删除的数据合并一起传给后端
      let finalParamData = [...formattedActiveData, ...formattedDeletedData];

      let params = {
        controlId: this.low.id,
        paramType: this.low.controlTypeVal,
        paramData: finalParamData,
      };
      updateSupplyControlParam(params).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.closeDig();
        }
      });
    },
    // 打开弹窗数据回显
    openSupplySet() {
      querySupplyControlParam({
        id: this.low.id,
        controlTypeVal: this.low.controlTypeVal,
      }).then((res) => {
        if (res.code == 1001) {
          const data = res.data.responseData;
          // 每次打开弹窗时，先清空删除记录
          this.deletedList = []; 
          if (data && Array.isArray(data) && data.length > 0) {
            const activeData = data.filter(d => d.status !== 0);
            if (activeData.length > 0) {
              this.globalConfirmDays = activeData[0].confirmDays;
              this.paramDataList = activeData.map(item => {
                let parsedGrades = item.strengthGrade ? JSON.parse(item.strengthGrade) : [];
                let mappedArr = parsedGrades.map(g => {
                  let match = this.strengthGradeList.find(dict => dict.name === g.name);
                  return match ? match.id : g.id;
                });
                return {
                  id: item.id, 
                  rate: item.rate,
                  strengthGradeArr: mappedArr
                };
              });
            } else {
              this.initEmptyData();
            }
          } else {
            this.initEmptyData();
          }
          this.dataType = 1;
        }
      });
    },
    // 初始化无数据空行的方法
    initEmptyData() {
      this.globalConfirmDays = "";
      this.paramDataList = [
        {
          id: "",
          strengthGradeArr: ["其他"],
          rate: "",
        }
      ];
    },
    choose(num) {
      this.dataType = num;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  margin: 12px 12px 12px 18px;
}

.text {
  display: flex;
  align-items: center;
}

.super-graph-content {
  padding: 10px 20px;
  background-color: #fcfcfc;
  border-radius: 4px;
}
</style>